import React, { Component } from 'react'
import PropTypes from 'prop-types'
import idGenerator from 'react-id-generator'
import { Language } from 'gatsby-plugin-i18next'

// Lets import components
import Slider from '../Slider/Slider'

// Lets import styles for component
import './VideosWrap.sass'

// Lets import utils
import {utils} from '../../utils/index'

class VideosWrap extends Component{
  render() {
    const { categories, videos, videoBlocks, activeCountry, t, l } = this.props
    const {lng} = this.props
    const filteredVideosByCategory = utils.filterVideosByCategory(categories, videoBlocks, videos)
    const videosToShow = utils.getVideosByLang(filteredVideosByCategory, lng)
    utils.sortVideosByCountry(videosToShow, activeCountry)
    return (
      <div className="container">
        {videosToShow.map(block => {
          return Object.hasOwnProperty.call(block, 'videosToShow') && block.videosToShow.length !== 0 ?
            (<div key={idGenerator()} className="categoryItem">
              <div className="customeTitle">
                {l.i18n.language === 'ru' ? block.titleRu : block.title}
              </div>
              <div className="sliderWrap">
                <Slider 
                  slides={Object.hasOwnProperty.call(block, 'videosToShow') 
                    ? block.videosToShow 
                    : []} 
                  activeCountry={activeCountry}
                  t={t}
                  l={l} />
              </div>
            </div>)
            : null
        })}
      </div>
    )
  }
}

export default props => (
  <Language>
    {lngProps => <VideosWrap {...props} {...lngProps} />}
  </Language>
)

VideosWrap.propTypes = {
  categories: PropTypes.array.isRequired,
  videos: PropTypes.array.isRequired,
  videoBlocks: PropTypes.array.isRequired,
  activeCountry: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}
